import service from "../service";
import { getApiBaseUrl } from "../config";

export default {
    async getPCList(param) {
        const response = await service.get(`${getApiBaseUrl()}pc`, param);
        return response;
    },

    async getPC(id) {
        const response = await service.get(`${getApiBaseUrl()}pc/${id}`);
        return response;
    },

    async addPC(pc) {
        const response = await service.post(`${getApiBaseUrl()}pc`, pc);
        return response;
    },

    async updatePC(pc) {
        const response = await service.patch(`${getApiBaseUrl()}pc`, pc);
        return response;
    },

    async deletePC(pc_id) {
        const response = await service.delete(
            `${getApiBaseUrl()}pc/${pc_id}`
        );
        return response;
    },

    async updateAnswer(pc_id, args) {
        const response = await service.patch(`${getApiBaseUrl()}pc/${pc_id}/answer`, args);
        return response;
    }
};
